<template>
    <div class="bg-white p-6 shadow-md">
        <h2 class="text-xl font-semibold text-gray-800 mb-4 flex items-center">
            <span class="mr-2">🎓</span>
            Graduation rates by program
        </h2>

        <div class="overflow-x-auto border border-gray-200">
            <table class="min-w-full text-sm text-gray-700 divide-y divide-gray-200">
                <thead class="bg-gray-100 text-xs uppercase font-semibold text-gray-600">
                    <tr>
                        <th class="px-6 py-3 text-left">Program Name</th>
                        <th class="px-6 py-3 text-center">Total Students</th>
                        <th class="px-6 py-3 text-center">Graduates</th>
                        <th class="px-6 py-3 text-center">Graduation Rate</th>
                    </tr>
                </thead>
                <tbody class="divide-y divide-gray-100">
                    <tr v-for="(item, index) in data" :key="index" class="hover:bg-gray-50 transition">
                        <td class="px-6 py-3 font-medium whitespace-nowrap truncate max-w-[250px]">
                            {{ item.program_name }}
                        </td>
                        <td class="px-6 py-3 text-center">{{ item.total_students }}</td>
                        <td class="px-6 py-3 text-center">{{ item.graduates }}</td>
                        <td class="px-6 py-3 text-center">
                            <span :class="[
                                'px-3 py-1 rounded-full text-xs font-bold',
                                getRateColor(item.graduation_rate)
                            ]">
                                {{ item.graduation_rate.toFixed(2) }}%
                            </span>
                        </td>
                    </tr>
                </tbody>
                <tfoot class="bg-gray-50 font-semibold text-gray-800 text-sm uppercase">
                    <tr>
                        <td class="px-6 py-3 text-left">Total</td>
                        <td class="px-6 py-3 text-center">{{ totalStudents }}</td>
                        <td class="px-6 py-3 text-center">{{ totalGraduates }}</td>
                        <td class="px-6 py-3 text-center">
                            {{ graduationPercentage.toFixed(2) }}%
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    name: "graduation-rates-by-program",
    props: ["data"],
    computed: {
        totalStudents() {
            return this.data.reduce((sum, item) => sum + item.total_students, 0);
        },
        totalGraduates() {
            return this.data.reduce((sum, item) => sum + item.graduates, 0);
        },
        graduationPercentage() {
            return this.totalStudents === 0
                ? 0
                : (this.totalGraduates / this.totalStudents) * 100;
        },
    },
    methods: {
        getRateColor(rate) {
            if (rate === 100) return "bg-green-100 text-green-700";
            if (rate >= 70) return "bg-green-50 text-green-600";
            if (rate >= 40) return "bg-yellow-100 text-yellow-700";
            if (rate > 0) return "bg-red-100 text-red-600";
            return "bg-gray-100 text-gray-500";
        },
    },
};
</script>

<style scoped>
/* Smooth hover transition */
tr {
    transition: background-color 0.2s ease;
}
</style>
